// components
import maInputRadio from '@/components/input/modules/radio'
import { COM_LAT, COM_LNG } from '@/constants'

/**
 * @module
 * @name Poligons
 */
export default {
  name: 'Poligons',

  /**
   * @property {Object} map Google map object.
   * @property {Object} poly Poligon Google map object.
   * @property {Number} area Measured area.
   * @property {Number} distance Measured distance.
   * @property {String} [dataType=surface] 'surface' or 'distance'.
   */
  data: function () {
    return {
      map: {},
      poly: {},
      area: 0,
      distance: 0,
      dataType: 'surface'
    }
  },

  /**
   * @property {Number} lat Lat coordinate.
   * @property {Number} lng Lng coordinate.
   * @property {String} type dataType, surface or distance.
   * @property {Boolean} viewer Manage if the select button is shown or not.
   */
  props: {
    lat: {
      type: String | Number,
      default: COM_LAT
    },
    lng: {
      type: String | Number,
      default: COM_LNG
    },
    type: {
      type: String
    },
    viewer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    maInputRadio
  },

  /**
   * @property {Float} comLat Lat set from property or default.
   * @property {Float} comLng Lng set from property or default.
   */
  computed: {
    comLat: function () {
      return this.lat ? this.lat : 48.864716
    },
    comLng: function () {
      return this.lng ? this.lng : 2.349014
    }
  },

  methods: {

    /**
     * @function
     * @name initMap
     * @description Inits google maps and add click listener.
     */
    initMap: function () {
      // eslint-disable-next-line
      this.map = new google.maps.Map(document.getElementById('map-poligons'), {
        zoom: 20,
        center: { lat: this.comLat, lng: this.comLng },
        mapTypeId: 'satellite',
        // panControl: false,
        panControlOptions: false,
        streetViewControl: false,
        tilt: 0,
        draggableCursor: 'pointer',
        rotateControl: false
      })
      this.map.addListener('click', this.handleMapClick)
    },

    /**
     * @function
     * @name initPolygonSurface
     * @description Init google.maps.polygon and set map to it.
     */
    initPolygonSurface: function () {
      // eslint-disable-next-line
      this.poly = new google.maps.Polygon({
        strokeColor: '#F2AA32',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#F2AA32',
        fillOpacity: 0.35,
        editable: true
      })
      this.poly.setMap(this.map)
    },

    /**
     * @function
     * @name initPolygonLine
     * @description Init google.maps.polyline and set map to it.
     */
    initPolygonLine: function () {
      // eslint-disable-next-line
      this.poly = new google.maps.Polyline({
        strokeColor: '#F2AA32',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        editable: true
      })
      this.poly.setMap(this.map)
    },

    /**
     * @function
     * @name mapSetCenter
     * @description Set map center with computed coordinates.
     */
    mapSetCenter () {
      this.map.setCenter(this.comLat, this.comLng)
    },

    /**
     * @function
     * @name handleMapClick
     * @param {Object} event
     * @description Add map points on click and his listeners for google events.
     */
    handleMapClick: function (event) {
      // new point polygon
      const path = this.poly.getPath()
      path.push(event.latLng)

      // add point move listener
      // eslint-disable-next-line
      google.maps.event.addListener(path, 'set_at', event => {
        this.handleConfirmPolygon()
      })

      // add point add listener
      // eslint-disable-next-line
      google.maps.event.addListener(path, 'insert_at', event => {
        this.handleConfirmPolygon()
      })

      this.handleConfirmPolygon()
    },

    /**
     * @function
     * @name handleClearMap
     * @description Clear area, distance and delete all points of polygon.
     */
    handleClearMap: function () {
      this.poly.setPath([])
      this.area = 0
      this.distance = 0
    },

    /**
     * @function
     * @name handleConfirmPolygon
     * @description Calculates distance and area, using spherical utilities from
     *              Google Maps library.
     */
    handleConfirmPolygon: function () {
      // eslint-disable-next-line
      this.area = google.maps.geometry.spherical.computeArea(this.poly.getPath())
      // eslint-disable-next-line
      this.distance = google.maps.geometry.spherical.computeLength(this.poly.getPath())
    },

    /**
     * @function
     * @name handleClickSelect
     * @description Emit event with dataType content value.
     */
    handleClickSelect: function () {
      if (this.dataType === 'surface') {
        this.$emit('change', this.area.toFixed(2))
      } else if (this.dataType === 'line') {
        this.$emit('change', this.distance.toFixed(2))
      }
    }
  },

  /**
   * @function
   * @name mounted
   * @description Init google map components.
   */
  mounted: function () {
    this.dataType = this.type
    // eslint-disable-next-line
    if (google) {
      this.initMap()
      if (this.dataType === 'surface') {
        this.initPolygonSurface()
        this.$el.querySelector('input[value="surface"]').click()
      } else if (this.dataType === 'line') {
        this.initPolygonLine()
        this.$el.querySelector('input[value="line"]').click()
      }
    }
  },

  /**
   * @property {function} lat Set map center when lat changes.
   * @property {function} lng Set map center when lng changes.
   * @property {function} dataType If dataType changes, polygon is reset according
   *                               to the new type.
   */
  watch: {
    lat: function () {
      this.mapSetCenter()
    },
    lng: function () {
      this.mapSetCenter()
    },
    dataType: function (newT, oldT) {
      if (oldT !== newT) {
        this.poly.setMap(null)
        this.area = 0
        this.distance = 0
        switch (newT) {
          case 'surface':
            this.initPolygonSurface()
            break
          case 'line':
            this.initPolygonLine()
            break
        }
      }
    }
  }
}
